import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

export type DpeTag = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G';

@Component({
  selector: 'app-dpe-2021',
  templateUrl: './dpe-2021.component.html',
  styleUrls: ['./dpe-2021.component.scss'],
  standalone: true,
  imports: [NgIf]
})
export class Dpe2021Component implements OnInit {
  @Input() energyValue: number;
  @Input() energyTag: DpeTag;
  @Input() gesValue: number;
  @Input() gesTag: DpeTag;

  valuesOk: boolean;
  energyTagImg: string;
  gesTagImg: string;
  energyTagClass: string;
  gesTagClass: string;
  showLabelBad: boolean;

  constructor() {}

  ngOnInit() {
    this.valuesOk = this.energyValue > 0 && this.energyTag !== null && this.gesValue > 0 && this.gesTag !== null;
    this.energyTagImg = `/assets/images/dpe/etiquette_energie_${this.energyTag}.png`;
    this.gesTagImg = `/assets/images/dpe/etiquette_gaz_${this.gesTag}.png`;
    this.energyTagClass = `tag-${this.energyTag.toLowerCase()}`;
    this.gesTagClass = `tag-${this.gesTag.toLowerCase()}`;
    this.showLabelBad = this.energyTag !== 'F' && this.energyTag !== 'G';
  }
}
